/**
 * @file 離脱メッセージ
 */
'use strict';

/**
 * @classname BeforeUnload
 * @classdesc 離脱メッセージ
 */
export default class BeforeUnload {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('BeforeUnload.constructor');
		this._$e = $e;
		this._next = false;
		$(window).on('beforeunload', (e) => {
			if(this._next) return;

			e.preventDefault();
			e.returnValue = "check";
			return '';
		})
		this._$e.on('click', () => {
			this._next = true;
		})
		$('#btn-download').on('click', () => {
			this._next = true;
		})
	};

	/**
	 * クリックコールバック
	 *
	 * @memberof BeforeUnload
	 */
	setListWidth() {
		console.log('BeforeUnload.setListWidth');
		const $list = this._$e.find('.list');
		let width = $list.width();
		let width2 = (width - 200) / 5;
		width2 = Math.floor(width2);
		width = width2 * 5 + 200;
		$list.css('width', `${width}px`);
	};
}
